import {
  useCallDetailsCallee,
  useCallDetailsCaller,
} from 'features/call/call-details/hooks';
import { CallDetailsCalleeConnected } from 'features/call/call-details/components';

export const CallDetailsCalleeConnectedContainer = () => {
  const { caller } = useCallDetailsCaller();
  const { callee } = useCallDetailsCallee();

  return <CallDetailsCalleeConnected caller={caller} callee={callee} />;
};
